export interface ProjectDependencyInput {
  projectIds: string;
}
